/* ============================================================================
   PRESSROOM — Motion altyapisi (FAZ 0)
   1. Paper -> ink zemin-mod motoru (spec 7): bolumlere data-bg-mode="paper|ink";
      tek ScrollTrigger <body> sinifini (.is-paper / .is-ink) viewport'a gore flip.
   2. Paylasilan scroll-reveal IO ([data-pr-reveal]).

   Kurallar:
   - Vendored GSAP + ScrollTrigger kullanir (assets/gsap.min.js,
     ScrollTrigger.min.js). CDN yok. GSAP yoksa zarifce dusup native calisir.
   - Hardcoded motion YOK: sure/easing CSS token'larindan getComputedStyle ile okunur.
   - prefers-reduced-motion: animasyon KURULMAZ; mod son durumda anlik uygulanir.
   ============================================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  var body = document.body;

  /* --- Token okuma yardimcisi (hardcoded sayi yasak) --------------------- */
  function readToken(name, fallback) {
    var v = getComputedStyle(root).getPropertyValue(name).trim();
    return v || fallback;
  }
  /* "420ms" / "0.42s" -> saniye (GSAP icin) */
  function toSeconds(token, fallbackSeconds) {
    if (!token) return fallbackSeconds;
    if (token.indexOf('ms') !== -1) return parseFloat(token) / 1000;
    if (token.indexOf('s') !== -1) return parseFloat(token);
    var n = parseFloat(token);
    return isNaN(n) ? fallbackSeconds : n;
  }

  /* --- Zemin modu uygulama (sinif flip) ---------------------------------- */
  function setMode(mode) {
    var isInk = mode === 'ink';
    body.classList.toggle('is-ink', isInk);
    body.classList.toggle('is-paper', !isInk);
  }

  /* --- Baslangic modu: ilk data-bg-mode'lu bolum, yoksa paper ------------ */
  function initialMode() {
    var first = document.querySelector('[data-bg-mode]');
    return (first && first.getAttribute('data-bg-mode') === 'ink') ? 'ink' : 'paper';
  }

  function init() {
    body.classList.add('pressroom-mode-engine');

    /* Zemin-mod motoru YALNIZ anasayfada calisir (musteri istegi): diger
       sayfalarda scroll'la renk degisimi YOK — govde sabit paper kalir.
       (Bayrak: theme.liquid <body data-pr-mode-engine="on|off">). Scroll-reveal
       ve marquee-gate her sayfada devam eder; sections bos gecilerek yalniz
       mod-flip gozlemcileri devre disi kalir. */
    var modeEngineOn = body.getAttribute('data-pr-mode-engine') !== 'off';
    setMode(modeEngineOn ? initialMode() : 'paper');

    var sections = [];
    if (modeEngineOn) {
      // GORUNMEZ (editorden gizlenmis / display:none / 0-yukseklik) bolumleri
      // haric tut: aksi halde gizli bir bolumun tetikleyicisi zemin modunu
      // "yapistirir" ve komsu ardisik bolumler yanlis renkte kalir (Yusuf:
      // ortadaki section gizlenince S/B gecisi eksik/uzun kaliyor).
      sections = Array.prototype.slice.call(document.querySelectorAll('[data-bg-mode]'))
        .filter(function (el) {
          return el.offsetParent !== null && el.getBoundingClientRect().height > 4;
        });
    }
    var revealEls = Array.prototype.slice.call(document.querySelectorAll('[data-pr-reveal]'));

    /* ---- reduced-motion: hicbir animasyon kurma; reveal'lar son durumda ---- */
    if (REDUCED) {
      revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
      // Mod motoru: viewport ortasinda hangi bolum varsa onun modunu anlik uygula.
      if (sections.length) {
        var applyImmediate = function () {
          var mid = window.innerHeight / 2;
          var active = sections[0];
          sections.forEach(function (s) {
            var r = s.getBoundingClientRect();
            if (r.top <= mid && r.bottom >= mid) active = s;
          });
          setMode(active.getAttribute('data-bg-mode') || 'paper');
        };
        applyImmediate();
        window.addEventListener('scroll', applyImmediate, { passive: true });
      }
      return;
    }

    var hasGSAP = typeof window.gsap !== 'undefined';
    var hasST = hasGSAP && typeof window.ScrollTrigger !== 'undefined';

    /* ---- Zemin-mod motoru: tek ScrollTrigger seti ---- */
    if (hasST) {
      window.gsap.registerPlugin(window.ScrollTrigger);
      sections.forEach(function (section) {
        var mode = section.getAttribute('data-bg-mode') || 'paper';
        window.ScrollTrigger.create({
          trigger: section,
          start: 'top center',
          end: 'bottom center',
          onEnter: function () { setMode(mode); },
          onEnterBack: function () { setMode(mode); }
        });
      });
    } else if (sections.length) {
      /* GSAP yoksa: IntersectionObserver fallback (viewport ortasi) */
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setMode(entry.target.getAttribute('data-bg-mode') || 'paper');
          }
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      sections.forEach(function (s) { io.observe(s); });
    }

    /* ---- Paylasilan scroll-reveal (tek IO, tum [data-pr-reveal]) ---- */
    if (revealEls.length) {
      var revealIO = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      revealEls.forEach(function (el) { revealIO.observe(el); });
    }

    /* ---- PERF: surekli CSS marquee'leri viewport-gate'le (spec 6) ----------
       Ticker (2 serit) + manifesto (2 serit) gibi sonsuz CSS animasyonlari
       ekran disindayken bos yere GPU kompozit eder. Tek paylasilan IO ile
       gorunur degilken [data-pr-paused] ekle -> CSS animation-play-state:paused
       (animasyonu dondurur, will-change layer'i serbest birakir). Tekrar
       gorununce devam. reduced-motion'da zaten animasyon yok; bu blok no-op. */
    var marquees = Array.prototype.slice.call(document.querySelectorAll('[data-pr-marquee]'));
    if (marquees.length && 'IntersectionObserver' in window) {
      var marqueeIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Gorunur -> oynat (paused attr kaldir); disinda -> duraklat.
          if (entry.isIntersecting) {
            entry.target.removeAttribute('data-pr-paused');
          } else {
            entry.target.setAttribute('data-pr-paused', '');
          }
        });
      }, { rootMargin: '200px 0px 200px 0px', threshold: 0 });
      marquees.forEach(function (el) {
        // Baslangicta gorunur degilse hemen duraklat (ilk frame'de bos is yapma).
        el.setAttribute('data-pr-paused', '');
        marqueeIO.observe(el);
      });
    }

    /* GSAP defaults'a token aktar (bolumler ortak ease/duration kullansin).
       Bolum spec'leri bu defaults'i ezebilir; hardcoded sayi tutmaz. */
    if (hasGSAP) {
      window.PRESSROOM = window.PRESSROOM || {};
      window.PRESSROOM.motion = {
        d: {
          micro: toSeconds(readToken('--d-micro'), 0.12),
          fast: toSeconds(readToken('--d-fast'), 0.24),
          base: toSeconds(readToken('--d-base'), 0.42),
          slow: toSeconds(readToken('--d-slow'), 0.72),
          theatrical: toSeconds(readToken('--d-theatrical'), 1.1)
        },
        mv: {
          xs: readToken('--mv-xs', '8px'),
          sm: readToken('--mv-sm', '16px'),
          md: readToken('--mv-md', '40px'),
          lg: readToken('--mv-lg', '80px'),
          parallax: readToken('--mv-parallax', '15%')
        },
        st: {
          tight: toSeconds(readToken('--st-tight'), 0.05),
          base: toSeconds(readToken('--st-base'), 0.08),
          loose: toSeconds(readToken('--st-loose'), 0.12)
        }
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
